import { render, staticRenderFns } from "./Objectives.vue?vue&type=template&id=281ab3c8&scoped=true&"
import script from "./Objectives.vue?vue&type=script&lang=js&"
export * from "./Objectives.vue?vue&type=script&lang=js&"
import style0 from "./Objectives.vue?vue&type=style&index=0&id=281ab3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ab3c8",
  null
  
)

export default component.exports